export const FETCH_COURSES_REQUEST = 'FETCH_COURSES_REQUEST';
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE';
export const RESET_COURSES_FAILURE = 'RESET_COURSES_FAILURE';

export const fetchCoursesRequest = schoolId => ({
  type: FETCH_COURSES_REQUEST,
  schoolId,
});

export const fetchCoursesSuccess = payload => ({
  type: FETCH_COURSES_SUCCESS,
  payload,
});

export const fetchCoursesFailure = error => ({
  type: FETCH_COURSES_FAILURE,
  payload: error,
});

export const resetCoursesFailure = () => ({ type: RESET_COURSES_FAILURE });
